import { render, staticRenderFns } from "./ScoreRecordsTable.vue?vue&type=template&id=8a3785dc&scoped=true"
import script from "./ScoreRecordsTable.vue?vue&type=script&lang=js"
export * from "./ScoreRecordsTable.vue?vue&type=script&lang=js"
import style0 from "./ScoreRecordsTable.vue?vue&type=style&index=0&id=8a3785dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3785dc",
  null
  
)

export default component.exports